// synced from loomweb blocks/file-read-block-view.tsx (de-Tailwind'd, read-only).
/**
 * File-read block. Faithful to loomweb's FileReadBlockView: header (icon +
 * "Reading files" + a Done badge), an optional active-text row, and the file list
 * (per-file status icon + monospace name). Tailwind classes are replaced by
 * namespaced `replay-*` CSS; lucide icons by the local inline-SVG set. loom's
 * clickable "open" affordance is dropped (read-only replay), so files render as
 * static rows.
 */
import type { JSX } from "react";
import type { FileReadBlock } from "@shared/loom-message-block";
import { FileTextIcon, CheckIcon, LoaderIcon } from "./icons";

export function FileReadBlockView({ block }: { block: FileReadBlock }): JSX.Element {
  const isInProgress = block.status === "in_progress" || block.status === "streaming";

  return (
    <div className="replay-block replay-file-read-block">
      <div className="replay-block-head">
        <FileTextIcon className="replay-icon replay-text-amber" />
        <span className="replay-block-label">Reading files</span>
        {block.status === "completed" && (
          <span className="replay-block-flag replay-text-success">
            <CheckIcon className="replay-icon-xs" />
            Done
          </span>
        )}
      </div>

      {isInProgress && (
        <div className="replay-block-active">
          {block.activeText !== undefined && block.activeText.length > 0
            ? block.activeText
            : `${block.completedFiles}/${block.totalFiles}`}
        </div>
      )}

      {block.files.length > 0 && (
        <div className="replay-file-list">
          {block.files.map((file) => (
            <div key={file.id} className="replay-file-row">
              {file.status === "reading" ? (
                <LoaderIcon className="replay-icon-xs replay-spin replay-text-primary" />
              ) : file.status === "completed" ? (
                <CheckIcon className="replay-icon-xs replay-text-success" />
              ) : (
                <span className="replay-icon-xs" />
              )}
              <span className="replay-file-name">{file.fileName}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
